import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { Fragment, useEffect, useState } from 'react';
import { exportCsvModalSxs } from './keywordResearchCSS';
import { exportCsvModalTexts } from 'src/common/config/TextMessage';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { KeywordOverviewTableCss } from './keywordOverview/keywordOverviewCSS';
export const ExportCsvModal = ({ handleExportModalClose, handleDownload }) => {
  const [loader, setLoader] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoader(false);
    }, 3000);
  }, []);
  return (
    <Fragment>
      <Box>
        {loader ? (
          <Box sx={exportCsvModalSxs?.mainBox}>
            <CircularProgress sx={exportCsvModalSxs?.loaderSx} />
            <Typography sx={exportCsvModalSxs?.text}>
              {exportCsvModalTexts?.generating}
            </Typography>
          </Box>
        ) : (
          <Box sx={exportCsvModalSxs?.mainBox}>
            <CheckCircleOutlineIcon sx={exportCsvModalSxs?.icon} />
            <Typography sx={exportCsvModalSxs?.text}>
              {exportCsvModalTexts?.success}
            </Typography>
            <Button
              variant="contained"
              fullWidth
              sx={{
                ...KeywordOverviewTableCss?.exportBtn,
                ...exportCsvModalSxs?.downloadBtn
              }}
              onClick={() => {
                handleDownload();
                handleExportModalClose();
              }}
            >
              {exportCsvModalTexts?.download}
            </Button>
          </Box>
        )}
      </Box>
    </Fragment>
  );
};
